import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box } from "@mui/material";
import Cookies from "js-cookie";
import DynamicDataGrid from "./dynamicDataGrid";

const jobTypeLabels = {
  H: "Hire",
  C: "Contract",
  C2H: "Contract to Hire",
  F: "Freelance Freenlance",
};

const ActiveJobs = ({ isActive, refreshKey, searchQuery }) => {
  const nav = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const prevSearchQuery = useRef(searchQuery);

  const [state, setState] = useState({
    activeJobs: [],
    isLoading: true,
    totalCount: 0,
    paginationModel: {
      page: Number(searchParams.get("page")) - 1 || 0,
      pageSize: 10,
    },
    sortModel: [{ field: "date_created", sort: "desc" }],
  });

  const { activeJobs, isLoading, totalCount, paginationModel, sortModel } =
    state;
  const normalizedSearchQuery = searchQuery.trim().toLowerCase();

  const updateState = (newValues) =>
    setState((prev) => ({ ...prev, ...newValues }));

  // ── Single Effect — API + page reset sab yahan ──
  useEffect(() => {
    const searchChanged = prevSearchQuery.current !== searchQuery;
    prevSearchQuery.current = searchQuery;

    // searchQuery change hone par page 0 pe fetch karo
    const pageToFetch = searchChanged ? 0 : paginationModel.page;

    // agar page bhi reset karna hai state mein
    if (searchChanged && paginationModel.page !== 0) {
      setState((prev) => ({
        ...prev,
        isLoading: true,
        paginationModel: { ...prev.paginationModel, page: 0 },
      }));
      return; // state update hogi, effect dobara chalega page: 0 ke saath
    }

    updateState({ isLoading: true });

    const searchPageSize = normalizedSearchQuery ? 1000 : paginationModel.pageSize;

    axios
      .post(
        `user/jobOrders/${normalizedSearchQuery ? 1 : pageToFetch + 1}`,
        {
          isActive,
          pageSize: searchPageSize,
          sortModel: sortModel[0],
        },
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      )
      .then((response) => {
        const jobs = response.data.message.resp_alljob || [];
        const filteredJobs = normalizedSearchQuery
          ? jobs.filter((job) => {
              const rawType = String(job.type || "").trim().toUpperCase();
              const searchableText = [
                job.title,
                rawType,
                jobTypeLabels[rawType] || job.type,
              ]
                .filter(Boolean)
                .join(" ")
                .toLowerCase();

              return searchableText.includes(normalizedSearchQuery);
            })
          : jobs;
        const rows = normalizedSearchQuery
          ? filteredJobs.slice(
              paginationModel.page * paginationModel.pageSize,
              paginationModel.page * paginationModel.pageSize +
                paginationModel.pageSize,
            )
          : filteredJobs;
        updateState({
          activeJobs: rows,
          totalCount: normalizedSearchQuery
            ? filteredJobs.length
            : response.data.message.total_jobs,
          isLoading: false,
        });
      })
      .catch(() => updateState({ isLoading: false }));
  }, [isActive, refreshKey, searchQuery, paginationModel, sortModel]);

  const handleSortModelChange = (model) => {
    if (isLoading) return;
    if (model.length > 0) {
      updateState({
        sortModel: model,
        isLoading: true,
        paginationModel: { ...paginationModel, page: 0 },
      });
      setSearchParams(searchQuery ? { page: 1, search: searchQuery } : { page: 1 });
    }
  };

  const handleRowClick = (row) => {
    const currentUrl = window.location.href;
    sessionStorage.setItem("JobpreviousUrl", currentUrl);
    nav(`/jobOrders/${row.id}`, {
      state: {
        id: row.id,
        title: row.title,
        type: row.type,
        status: row.status,
        date_created: row.date_created,
        count: row.count,
        openapplication: row.open_count,
      },
    });
  };

  const handlePaginationModelChange = (model) => {
    updateState({ paginationModel: model });
    setSearchParams(
      searchQuery
        ? { page: model.page + 1, search: searchQuery }
        : { page: model.page + 1 },
    );
  };

  return (
    <Box
      sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}
    >
      <DynamicDataGrid
        rows={activeJobs}
        loading={isLoading}
        showCheckbox={false}
        name={"ActiveJobs"}
        onRowSelection={handleRowClick}
        totalRows={totalCount}
        paginationModel={paginationModel}
        onPaginationModelChange={handlePaginationModelChange}
        sortModel={sortModel}
        onSortModelChange={handleSortModelChange}
      />
    </Box>
  );
};

export default ActiveJobs;
